<template>
  <div class="flow-wrapper">
    <div
      v-if="props.type === 'SaquePw'"
      class="text-center bg-[var(--inner-table-bg-color70)] h-[44px] flex items-center justify-center relative "
    >
      <div class="text-lg text-white !text-[16px]">
        {{ currentTitle }}
      </div>
      <img
        class="w-[24px] h-[24px] absolute right-2"
        :src="closeIcon"
        @click="emit('close')"
        alt="close"
      />
    </div>

    <div
      v-if="props.type === 'Saque' || props.type === 'Deposit'"
      class="h-[50px] flex items-center relative mx-4"
    >
      <div class="text-[var(--theme-primary)] !text-[18px] w-full ml-8">
        {{ currentTitle }}
      </div>

      <div class="absolute bottom-[-5px] left-0 w-full z-10">
        <div class="h-[2px] w-2/5 bg-[var(--theme-primary)] inline-block"></div>
        <div class="h-[1px] w-3/5 bg-[var(--theme-game-flow-line)] inline-block"></div>
      </div>
      <img
        class="w-[24px] h-[24px] absolute right-0"
        :src="closeIcon"
        @click="emit('close')"
        alt="close"
      />
    </div>
    <div class="content">
      <component
        :is="stepComponents[currentStep-1]"
        :flow-data="flowData"
        @next="goToNext"
        @prev="goToPrev"
        @finish="handleFinish"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, defineProps, defineEmits } from "vue";
//设置取款密码组件
import SaquePwCompontents from "@/views/SaquePw/SaquePwCompontents.vue";
// 提现流程组件
import SaqueCompontents from "@/views/Saque/SaqueCompontents.vue";
// 充值流程组件  充值二维码组件   充值结果组件
import DepositCompontents from "@/views/Deposito/DepositoCompontents.vue";
import DepositQRcodeCompontents from "@/views/DepositoQRcode/DepositoQRcodeCompontents.vue";
import DepositResultsCompontents from "@/views/DepositoResults/DepositoResultsCompontents.vue";
import { useI18n } from "vue-i18n";
import closeIcon from "@/assets/images/i_close.png";
const props = defineProps({
  type: { type: String, default: "" },
  initialData: { type: Object, default: () => ({}) },
});
const emit = defineEmits(["close", "finish"]);
const { t } = useI18n();
const stepComponents = ref([]);
const currentStep = ref(1);
const currentTitle = ref("");
const titles = {
  SaquePw: t("meu.Saque.Title"),
  Saque: t("meu.Sake"),
  Deposit: t("meu.Deposit"),
};

const flowData = reactive({ ...props.initialData }); // 使用初始数据

const goToNext = (step,stepData) => {
  Object.assign(flowData, stepData);
  if (currentStep.value < stepComponents.value.length) currentStep.value = Number(step);
};
const goToPrev = () => {
  if (currentStep.value > 1) currentStep.value--;
};
const handleFinish = (result) => {
  emit("finish", result); // 流程成功，通知外部
};
onMounted(() => {
  switch (props.type) {
    case "SaquePw":
      stepComponents.value = [SaquePwCompontents];
      currentTitle.value = titles.SaquePw;
      break;
    case "Saque":
      stepComponents.value = [SaqueCompontents];
      currentTitle.value = titles.Saque;
      break;
    case "Deposit":
      stepComponents.value = [DepositCompontents,DepositQRcodeCompontents,DepositResultsCompontents];
      currentTitle.value = titles.Deposit;
      break;
    default:
      break;
  }
});
</script>
<style scoped>
.flow-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--theme-game-flow-bg);
  width: 95%;
  margin: 0 auto;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
}
.content {
  flex: 1;
  overflow-y: auto;
}
</style>
